// Function to generate section data
const getSectionData = (id, section, selector) => ({ id, section, selector });

// Check cart drawer and set sections to render
const cartDrawer = document.querySelector('cart-drawer');
const cartDrawerSectionId = cartDrawer?.closest('[id^="shopify-section"]')?.id.replace('shopify-section-', '') || 'cart-drawer';
let sectionsToRender = [];

if (cartDrawer) {
  const mainCartId = document.getElementById('main-cart-items')?.dataset.id;
  if (mainCartId) {
    sectionsToRender = [
      getSectionData(`#shopify-section-${mainCartId}`, mainCartId, `#shopify-section-${mainCartId} cart-items`),
      getSectionData("#cart-counter", "cart-counter", "#shopify-section-cart-counter"),
      getSectionData("#CartDrawer-Body", cartDrawerSectionId, "#CartDrawer-Body")
    ];
  } else {
    sectionsToRender = [
      getSectionData("#CartDrawer-Body", cartDrawerSectionId, "#CartDrawer-Body"),
      getSectionData(".cart-drawer__title-counter", cartDrawerSectionId, ".cart-drawer__title-counter"),
      getSectionData("#cart-counter", "cart-counter", "#shopify-section-cart-counter")
    ];
  }
} else {
  const mainCartId = document.getElementById('main-cart-items')?.dataset.id;
  if (mainCartId) {
    sectionsToRender = [
      getSectionData(`#shopify-section-${mainCartId}`, mainCartId, `#shopify-section-${mainCartId} cart-items`),
      getSectionData('#cart-counter', 'cart-counter', '#shopify-section-cart-counter')
    ];
  } else {
    sectionsToRender = [];
  }
}

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', event => {
      event.preventDefault();
      const cartItems =
        this.closest('cart-drawer-items') ||
        this.closest('cart-items');

      const variants = window.theme.settings.shipping_protection_product_data?.variants;
      const hasProtectionProduct = variants && variants.length > 0 && variants.some(variant => variant.id == this.dataset.lineId);
      if (hasProtectionProduct) {
        setCookie('shipping_protection', 'removed', 1);
      }

      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}
customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.freeShipping = document.querySelectorAll('shipping-bar');

    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce(event => {
      this.onChange(event);
    }, 300);
    this.addEventListener(
      'change', this.debouncedOnChange.bind(this)
    );

    updateFreeShipping();
  }

  calculateTotalItemCount(items) {
    return items.reduce((total, item) => total + item.quantity, 0);
  }

  onChange(event) {
    if (event.target.name !== 'updates[]') return;

    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute('name')
    );
  }

  getSectionsToRender() {
    return sectionsToRender;
  }

  updateQuantity(line, quantity, name) {
    this.classList.add('is-loading');
    let subItems = this.querySelector(`#CartItem-${line}`).querySelector('.cart-item__quantity').dataset.subIds
    const subItemsObj = {};

    if(subItems && subItems.length > 0){
      const itemsArray = Array.isArray(subItems) ? subItems : subItems.split(',');

      // Create object with each subItem as key and quantity as value
      itemsArray.forEach(item => {
        if (item && item.trim()) {
          subItemsObj[item.trim()] = parseInt(quantity, 10);
        }
      });

      const body = JSON.stringify({
        updates: subItemsObj,
        sections: this.getSectionsToRender().map(section => section.section),
        sections_url: window.location.pathname,
      });
      fetch(`${routes.cart_update_url}`, {
        ...fetchConfig(),
        ...{ body }
      })
        .then(response => response.text())
        .then(state => {
          updateAfterCartChange(state);
          if(document.querySelector('rewards-popup')) {
            document.querySelector('rewards-popup').updateCart(JSON.parse(state));
          }
        })
        .finally(() => this.classList.remove('is-loading'));
    }else{
      const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map(section => section.section),
        sections_url: window.location.pathname
      });

      fetch(`${routes.cart_change_url}`, {
        ...fetchConfig(),
        ...{ body }
      })
        .then(response => response.text())
        .then(state => {
          updateAfterCartChange(state);
          if(document.querySelector('rewards-popup')) {
            document.querySelector('rewards-popup').updateCart(JSON.parse(state));
          }
        })
        .finally(() => this.classList.remove('is-loading'));
    }
    const updateAfterCartChange = (state) => {
      const parsedState = JSON.parse(state);
      this.getSectionsToRender()?.forEach(section => {
        const matches = document.querySelectorAll(section.selector).length
          ? document.querySelectorAll(section.selector)
          : document.querySelectorAll(section.id);

        if (matches.length) {
          if (!parsedState.errors) {
            const html = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
            matches.forEach(elementToReplace => {
              elementToReplace.innerHTML = html;
            });
          }
        } else {
          console.error(`Element with selector ${section.selector} not found`);
        }

      });
      if (!parsedState.errors) {
        this.totalItemCount = this.calculateTotalItemCount(parsedState.items);
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'cart-drawer',
          cartData: parsedState,
        });
      }
      this.updateLiveRegions(line, parsedState.item_count, parsedState.errors);

      const lineItem = document.getElementById(`CartItem-${line}`);
      if (lineItem && lineItem.querySelector(`[name="${name}"]`))
        lineItem.querySelector(`[name="${name}"]`).focus();

      updateFreeShipping();
      protectionProduct();

      const bundleBuilderPopup = document.querySelector('bundle-builder-popup');
      if (bundleBuilderPopup) {
        bundleBuilderPopup.boundHandleCartUpdate({ cartData: parsedState });
      }
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  updateLiveRegions(line, itemCount, parsedError) {
    if (parsedError) {
      document
        .querySelectorAll(`[data-line-item-error][data-line="${line}"]`)
        .forEach(error => {
          error.innerHTML = parsedError;
        });
    }

    this.currentItemCount = itemCount;
  }
}
customElements.define('cart-items', CartItems);

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("keyup", event => event.code.toUpperCase() === "ESCAPE" && this.close());
    this.setCartLink();
    this.parentElement.addEventListener("shopify:section:select", () => this.open());
    this.parentElement.addEventListener("shopify:section:deselect", () => this.close());
  }

  setCartLink() {
    const cartLinks = document.querySelectorAll("[data-cart-link]");
    if (!cartLinks.length) {
      console.error("Cart link not found");
      return;
    }

    cartLinks.forEach(cartLink => {
      if (cartLink.dataset.cartLinkBound === "true") return;
      cartLink.dataset.cartLinkBound = "true";
      cartLink.setAttribute("role", "button");
      cartLink.setAttribute("aria-haspopup", "dialog");
      cartLink.addEventListener("click", event => {
        event.preventDefault();
        this.open(cartLink);
      });
      cartLink.addEventListener("keydown", event => {
        if (event.code.toUpperCase() !== "SPACE") return;
        event.preventDefault();
        this.open(cartLink);
      });
    });
  }

  open(opener) {
    if (opener) this.setActiveElement(opener);
    this.classList.add("is-visible");
    document.querySelector('body').style.overflow = 'hidden';
    this.addEventListener("transitionend", () => { this.focusOnCartDrawer(); }, { once: true });

    setTimeout(() => {
      document.addEventListener("click", this.handleOutsideClick);
    }, 100);

    const productReccomendations = document.querySelector(".product-recommendations");
    const drawerItems = document.querySelector(".cart-drawer-items");
    if (productReccomendations && drawerItems) {
      if (productReccomendations.classList.contains("hidden")) {
        drawerItems.classList.add("cart-drawer-items__full");
      } else {
        drawerItems.classList.remove("cart-drawer-items__full");
      }
    }
  }

  close() {
    this.classList.remove("is-visible");
    document.querySelector('body').style.overflow = '';
    document.querySelector('body').style.overflowX = 'hidden';
    removeTrapFocus(this.activeElement);

    document.removeEventListener("click", this.handleOutsideClick);

    const activeHeader =
      typeof getActiveHeaderEl === "function" ? getActiveHeaderEl() : header;
    const isHeaderMenuOpen =
      activeHeader && activeHeader.classList.contains("menu-open");

    if (isHeaderMenuOpen) {
      return;
    }

    // if we are on the cart page, resubmit form
    if (window.location.pathname === "/cart") {
      const cartDrawerForm = document.getElementById("CartDrawer-FormSummary");
      if (cartDrawerForm) {
        cartDrawerForm.submit();
      }
    }
  }

  handleOutsideClick = event => {
    const cartDrawerInner = this.querySelector(".cart-drawer__inner");

    const clickedElement = event.target;
    const isOmnisendClick = 
      clickedElement.closest('#omnisend-forms-wrapper') ||
      clickedElement.closest('[class*="omnisend-"]') ||
      clickedElement.closest('[id*="omnisend-"]');
    const isColourDrawerOpen = !!this.querySelector('colour-drawer details[open]');
    const isUpsellOpen = !!document.querySelector('cart-upsell details[open]');
    const isParcelProtectionClick = !!clickedElement.closest('.parcel-protection-modal');
    const isBundlePopupClick = clickedElement.closest('[data-bundle-popup]');

    if (
      cartDrawerInner &&
      !cartDrawerInner.contains(event.target) &&
      !isOmnisendClick &&
      !isColourDrawerOpen &&
      !isUpsellOpen &&
      !isParcelProtectionClick &&
      !isBundlePopupClick
    ) {
      this.close();
    } else if (isColourDrawerOpen && !this.querySelector('colour-drawer:has(details[open])')?.contains(clickedElement)) {
      this.querySelector('colour-drawer:has(details[open])')?.btnsCloseDrawer?.[0]?.click();
    } else if (isUpsellOpen && !document.querySelector('cart-upsell:has(details[open])')?.contains(clickedElement)) {
      document.querySelector('cart-upsell:has(details[open])')?.close(event, false);
    }
  };

  setActiveElement(element) {
    this.activeElement = element;
  }

  focusOnCartDrawer() {
    const containerToTrapFocusOn = this.firstElementChild;
    const focusElement = this.querySelector("[data-drawer-close]");
    trapFocus(containerToTrapFocusOn, focusElement);
  }

  renderContents(response, open = true) {
    if(document.querySelector('rewards-popup')) {
      document.querySelector('rewards-popup').updateCart(response);
    }

    if(document.querySelector('bundle-builder-popup')) {
      document.querySelector('bundle-builder-popup').boundHandleCartUpdate(response);
    }

    protectionProduct(response);
    this.getSectionsToRender()?.forEach(section => {
      const sectionElement = document.querySelector(section.id);
      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(
        response.sections[section.section],
        section.selector
      );

      updateCartCounters();
    });
    // Keep collection shopping uninterrupted while the bundle progress is shown.
    const hasCollectionBundleProgress =
      document.body.matches('.template--collection') &&
      document.querySelector('collection-bundle-progress');
    if (!open || hasCollectionBundleProgress) {
      return;
    }

    this.open();
  }

  getSectionsToRender() {
    return sectionsToRender;
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }
}
customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return sectionsToRender;
  }
}
customElements.define("cart-drawer-items", CartDrawerItems);

window.subscribe(PUB_SUB_EVENTS.cartUpdate, (data) => {
  const cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer || !data?.cartData?.sections) return;

  const wheel = document.querySelector('wheel-element');
  if (wheel?.spinning) {
    console.log('Setting pending cart render', data.cartData);
    wheel.setPendingCartRender(data.cartData);
    return;
  }

  cartDrawer.renderContents(data.cartData, data.source !== 'shipping-protection');
});

let updatingprotectionProduct = false;

async function protectionProduct(preloadedCart = null) {
  if (!window.theme.settings.shipping_protection_enabled || updatingprotectionProduct || getCookie('shipping_protection') === 'removed') return;
  const productId = window.theme.settings.shipping_protection_product_data.id;
  const variants = window.theme.settings.shipping_protection_product_data.variants;
  const threshold = window.theme.settings.shipping_protection_product_data.threshold;

  let variantId = variants[0].id;

  updatingprotectionProduct = true;

  const cartPromise = (preloadedCart && preloadedCart.total_price !== undefined && Array.isArray(preloadedCart.items))
    ? Promise.resolve(preloadedCart)
    : fetch('/cart.js').then(response => response.json());

  cartPromise.then(async cart => {
      if(cart.total_price > threshold){
        variantId = variants[1].id;
      }

      let hasProtectionProduct = cart.items.some(item => item.product_id == productId);
      const protectionProduct = cart.items.find(item => item.product_id == productId);

      if (cart.items.length == 0 || (cart.items.length > 1 && protectionProduct?.quantity == 1 && protectionProduct?.variant_id == variantId )) {
        updatingprotectionProduct = false;
        return;
      }
      
      if(hasProtectionProduct && cart.total_price - protectionProduct?.price > threshold && protectionProduct?.variant_id !== variantId){
        if (!await removeProtectionProduct(protectionProduct?.variant_id, 0)) return;
        hasProtectionProduct = false;
      } else if(hasProtectionProduct && cart.total_price - protectionProduct?.price <= threshold && protectionProduct?.variant_id !== variantId){
        if (!await removeProtectionProduct(protectionProduct?.variant_id, 0)) return;
        hasProtectionProduct = false;
      }

      if (!hasProtectionProduct && cart.items.length > 0) {
        const body = JSON.stringify({
          items: [{
            id: variantId,
            quantity: 1
          }],
          sections: sectionsToRender.map(section => section.section),
          sections_url: window.location.pathname
        });
        fetch('/cart/add.js', {
          ...fetchConfig(),
          ...{ body }
        })
          .then(response => response.text())
          .then(async state => {
            const parsedState = JSON.parse(state);
            if(parsedState.items[0].quantity > 1){
              await removeProtectionProduct(variantId, 1);
            }
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer) {
              cartDrawer.renderContents(JSON.parse(state), false);
            }
            updatingprotectionProduct = false;
            updateCartCounters();
          });
      } else if (hasProtectionProduct && cart.items.length === 1) {
        removeProtectionProduct(protectionProduct?.variant_id, 0);
      } else {
        updatingprotectionProduct = false;
        updateCartCounters();
      }
    });
}

async function removeProtectionProduct(variantId, quantity = 0) {
  const body = JSON.stringify({
    updates: { [variantId]: quantity },
    sections: sectionsToRender.map(section => section.section),
    sections_url: window.location.pathname
  });
  try {
    const response = await fetch(routes.cart_update_url, {
      ...fetchConfig(),
      body
    });
    const cartData = await response.json();
    if (!response.ok || cartData.errors || cartData.status) {
      throw new Error(cartData.description || cartData.message || 'Please refresh your cart and try again.');
    }
    const validSections = sectionsToRender.every(section => {
      const html = cartData.sections?.[section.section];
      return typeof html === 'string' && new DOMParser().parseFromString(html, 'text/html').querySelector(section.selector);
    });
    if (!validSections) throw new Error('Your cart changed. Please refresh to see the latest items.');
    publish(PUB_SUB_EVENTS.cartUpdate, { source: 'shipping-protection', cartData });
    return cartData;
  } catch (error) {
    const message = error.message || 'Please refresh your cart and try again.';
    document.querySelectorAll('[data-line-item-error]').forEach(element => {
      element.textContent = message;
    });
    publish(PUB_SUB_EVENTS.cartError, { source: 'shipping-protection', errors: message, message });
    console.error('Parcel protection update failed:', error);
    return null;
  } finally {
    updatingprotectionProduct = false;
  }
}
